export default "__VITE_ASSET__CcD9rxZd__"